import { Encoder } from '../../types/Encoder';
import { Stream } from '../../types/Stream';

export const getSourceEncoder = (stream: Stream | undefined): Encoder | null => {
  if (!stream || !stream?.encoders || stream?.encoders?.length === 0) {
    return null;
  }

  return stream?.encoders.find((x) => x.languageIsoCode === stream.sourceLanguageIsoCode) || null;
};
